import React, { Dispatch } from 'react';
import {
    Formik,
    Form,
    Field,
} from 'formik';
import {CalculatedRainWater, Marker} from "./App";
import "./DataForm.scss"
import * as Yup from 'yup';
import { getIconUrl } from "./helpers";

import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'

const DataFormSchema = Yup.object().shape({
    roofArea: Yup.number().min(1, 'Minimalna wartość to 1 m2').required('Pole jest wymagane'),
    gardenArea: Yup.number().min(1, 'Minimalna wartość to 1 m2').required('Pole jest wymagane'),
    enableExtraFields: Yup.boolean(),
    numberPeople: Yup.number().when("enableExtraFields", {
        is: true,
        then: (schema) => schema.min(1, 'Minimalna wartość to 1 osoba').required('Pole jest wymagane'),
    }),
    waterUses: Yup.array().when("enableExtraFields", {
        is: true,
        then: (schema) => schema.min(1, 'Wybierz przynajmniej jeden sposób zastosowania').required('Pole jest wymagane'),
    }),
});


const roofMaterialOptions = [
    {
        label: "Dach skośny pokryty dachówką ceramiczną lub blachą",
        value: 0.9
    },
    {
        label: "Dach skośny pokryty dachówką betonową",
        value: 0.8
    },
    {
        label: "Dach płaski",
        value: 0.6
    },
    {
        label: "Dach zielony",
        value: 0.3
    },
];

export interface DataFormValues {
    roofArea: number|undefined;
    roofMaterial: number;
    gardenArea: number|undefined;
    numberPeople: number|undefined;
    waterUses: Array<string>;
    enableExtraFields: boolean;
}

type Props = {
    marker: Marker | undefined;
    setCalculatedRainWater: Dispatch<CalculatedRainWater|null>
    setStep: Dispatch<string>,
    formValues: DataFormValues,
    setFormValues: Dispatch<DataFormValues>
}
function DataForm({marker, setCalculatedRainWater, setStep, formValues, setFormValues}: Props) {
    if (!marker || !marker.rainWater) {
        return null;
    }

    const prevStep = (e: React.MouseEvent) => {
        e.preventDefault();
        setStep('selectLocation')
    }

    const validate = (values: DataFormValues) => {
        setFormValues(values);
        return {}
    }

    const getSizeTank = (l: number): number|null => {
        if (l <= 2000) {
            return 2000;
        }

        if (l <= 3000) {
            return 3000;
        }

        if (l <= 4500) {
            return 4500;
        }

        if (l <= 6000) {
            return 6000;
        }

        return 7000;
    }

    return (
        <div className="DataForm container">
            <div className="row">
                <div className="description">
                    <div className="col-md-12">
                        <h2>KROK II</h2>
                        <h3>INFORMACJA O RODZAJU DACHU I SPOSOBACH WYKORZYSTANIA DESZCZÓWKI:</h3>
                        W kolejnym kroku, należy podać nieco dokładniejsze informacje o nieruchomości na której instalowany będzie zbiornik. Dane o dachu budynku pozwolą określić jak radzi on sobie ze zbieraniem opadów deszczu. Podanie powierzchni ogrodu i określenie innych zadań umożliwi kalkulatorowi prognozowanie zapotrzebowania na deszczówkę.
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-9 col-lg-8 col-xl-7">
            <Formik
                initialValues={formValues}
                validate={validate}
                validationSchema={DataFormSchema}
                onSubmit={(values, actions) => {
                    console.log({ values, actions });
                    console.log(JSON.stringify(values));
                    actions.setSubmitting(false);

                    const gardenWater = Number(values.gardenArea) * 60;
                    const wcWater = values.numberPeople && values.numberPeople > 0 && values.waterUses.includes('wc') ? values.numberPeople * 9015 : 0;
                    const washingMachineWater = values.numberPeople && values.numberPeople > 0 && values.waterUses.includes('washingMachine') ? values.numberPeople * 3685 : 0;
                    const carWashWater = values.numberPeople && values.numberPeople > 0 && values.waterUses.includes('carWash') ? values.numberPeople * 800 : 0;
                    // @ts-ignore
                    const expectedRainWater = marker.rainWater * Number(values.roofArea) * values.roofMaterial;
                    const requiredRainWater = gardenWater + wcWater + washingMachineWater + carWashWater;
                    const calcSizeTank = ((expectedRainWater + requiredRainWater)/2) * (21/365);
                    const calcRecommendedSizeTank = calcSizeTank * 2;
                    console.log('calcSizeTank', calcSizeTank);
                    console.log('calcRecommendedSizeTank', calcRecommendedSizeTank);

                    setCalculatedRainWater({
                        // @ts-ignore
                        expectedRainWater: expectedRainWater,
                        requiredRainWater: requiredRainWater,
                        minSizeTank: getSizeTank(calcSizeTank),
                        recommendedSizeTank: getSizeTank(calcRecommendedSizeTank)
                    })

                    setStep('summary')
                }}
            >
                {({ values, errors, touched , submitForm}) => ( <Form>
                        <div className={"form-row"}>
                            <h3>Określ powierzchnię dachu i materiał jego pokrycia</h3>
                            <span className={"field-wrapper"}>
                                <div className={"field-icon"}>
                                     <img  src={getIconUrl('roof-2.svg')} />
                                </div>
                                <div className={"field-data"}>
                                    <label htmlFor="roofArea"><div className='title-container'>Powierzchnia dachu (rzut z góry)<a className='tooltip-icon' data-tooltip-id="dataform-tooltip" data-tooltip-content="Dla dachów skośnych powierzchnia dachu mierzona w bezpośrednim rzucie z góry, a dla dachów płaskich powierzchnia całkowita. Dla większej dokładności można wziąć pod uwagę tylko te obszary dachu, których orynnowanie będzie kierować wodę do zbiornika."><span>?</span></a></div></label>
                                <span className={"field-input-wrapper"}>
                                    <Field
                                        id="roofArea"
                                        name="roofArea"
                                        type={"number"}
                                        className={`input-text ${touched.roofArea && errors.roofArea ? 'is-invalid' : ''}`}
                                    /> m2
                                </span>
                                {touched.roofArea && errors.roofArea && (
                                    <span className='error-text'>{errors.roofArea}</span>
                                )}
                                    </div>
                            </span>

                            <span className={"field-wrapper"}>
                                 <div className={"field-icon"}>
                                     <img  src={getIconUrl('roof-1.svg')} />
                                </div>
                                <div className={"field-data"}>
                                    <label htmlFor="roofArea"><div className='title-container'>Rodzaj nachylenia i materiał pokrycia dachu <a className='tooltip-icon' data-tooltip-id="dataform-tooltip" data-tooltip-content="Wybierz jedną z 4 dostępnych opcji określających materiał i nachylenie Twojego dachu"><span>?</span></a></div></label>
                                    <span className={"field-input-wrapper"}>
                                        <Field
                                            as="select"
                                            id="roofMaterial"
                                            name="roofMaterial"
                                            options={roofMaterialOptions}
                                            className={"input-text"}
                                        >
                                        {roofMaterialOptions.map(({label, value}) =>
                                            <option value={value} key={'roofMaterial_' + value}>{label}</option>)}
                                        </Field>
                                    </span>
                                </div>
                            </span>

                            <h3>Zapotrzebowanie na wodę deszczową w twoim ogrodzie</h3>
                            <span className={"field-wrapper"}>
                                <div className={"field-icon"}>
                                     <img  src={getIconUrl('flowers.svg')} />
                                </div>
                                <div className={"field-data"}>
                                    <label htmlFor="gardenArea"><div className='title-container'>Powierzchnia ogrodu przeznaczona do podlewania <a className='tooltip-icon' data-tooltip-id="dataform-tooltip" data-tooltip-content="Podaj przybliżoną powierzchnię w Twoim ogrodzie, którą zamierzasz podlewać wodą ze zbiornika. Dla większej dokładności możesz odliczyć od niej powierzchnię na np. podjazdy, chodniki i tereny nawadniane z innego źródła"><span>?</span></a></div></label>
                                    <span className={"field-input-wrapper"}>
                                        <Field
                                            id="gardenArea"
                                            name="gardenArea"
                                            type={"number"}
                                            className={`input-text ${touched.gardenArea && errors.gardenArea ? 'is-invalid' : ''}`}
                                        /> m2
                                    </span>
                                    {touched.gardenArea && errors.gardenArea && (
                                        <span className='error-text'>{errors.gardenArea}</span>
                                    )}
                                </div>
                            </span>

                            <div className='title-container'>
                                <h3>Zapotrzebowanie na wodę deszczową w twoim domu</h3>
                                <a className='tooltip-icon' data-tooltip-id="dataform-tooltip" data-tooltip-content="Dla rozwiązań wykorzystania wody deszczowej w domu (przy zastosowaniu dodatkowego filtrowania wody)"><span>?</span></a>
                            </div>

                            <span className={"field-wrapper"}>
                                <div className={"field-icon"}>
                                     <div className={"field-icon fake-img"} />
                                </div>
                                <div className={"field-data"}>
                                    <span className={"field-input-wrapper"}>
                                        <Field type="checkbox" name="enableExtraFields" /> Woda będzie wykorzystywana również do innych celów np. WC, Pralka, Mycie auta
                                    </span>
                                </div>
                            </span>
                            {values.enableExtraFields && <div>
                                <span className={"field-wrapper"}>
                                    <div className={"field-icon"}>
                                     <img  src={getIconUrl('people.svg')} />
                                    </div>
                                    <div className={"field-data"}>
                                        <label htmlFor="numberPeople">Ilość osób w gospodarstwie domowym</label>
                                        <span className={"field-input-wrapper"}>
                                            <Field
                                                id="numberPeople"
                                                name="numberPeople"
                                                type={"number"}
                                                className={`input-text ${touched.numberPeople && errors.numberPeople ? 'is-invalid' : ''}`}
                                            /> osób
                                        </span>
                                        {touched.numberPeople && errors.numberPeople && (
                                            <span className='error-text'>{errors.numberPeople}</span>
                                        )}
                                    </div>
                                </span>

                                <span className={"field-wrapper"}>
                                    <div className={"field-icon"}>
                                     <img  src={getIconUrl('washing-machine.svg')} />
                                    </div>
                                    <div className={"field-data"}>
                                        Określ potencjalne sposoby wykorzystania zebranej wody deszczowej w twoim domu:
                                        <br/>
                                        <label className={"checkbox-field-wrapper"}>
                                            <Field
                                                type="checkbox"
                                                name="waterUses"
                                                value="wc"
                                            />
                                            WC - spłukiwanie
                                        </label>
                                        <label className={"checkbox-field-wrapper"}>
                                            <Field type="checkbox" name="waterUses" value="washingMachine" />
                                            Pralka - pranie automatyczne
                                        </label>
                                        <label className={"checkbox-field-wrapper"}>
                                            <Field type="checkbox" name="waterUses" value="carWash" />
                                            Prace porządkowe i mycie auta
                                        </label>
                                        {touched.waterUses && errors.waterUses && (
                                            <span className='error-text'>{errors.waterUses}</span>
                                        )}
                                    </div>
                                </span>
                            </div>}

                            <div className={'bottom-buttons'}>
                                <div>
                                    <a className={"yellow-button"} onClick={prevStep}>Wstecz</a>
                                </div>

                                <div>
                                    <a className={"yellow-button"} onClick={submitForm}>Oblicz</a>
                                </div>
                            </div>
                            <Tooltip id="dataform-tooltip" />
                        </div>
                </Form>
                )}
            </Formik>
        </div>
            </div>
        </div>
    );
}

export default DataForm;
